//Banners
import womensBanner from "../assets/images/subspecialities/shape banners/womensImgBanner.png";
import MensBanner from "../assets/images/subspecialities/shape banners/MensImgBanner.png";
import NeurologicalBanner from "../assets/images/subspecialities/shape banners/NuroImgBanner.png";
import BodyImagingBanner from "../assets/images/subspecialities/shape banners/BodyImagingShape.png";
import personalInjuryBanner from "../assets/images/subspecialities/shape banners/InjuryImgBanner.png";
import CardiacImagingBanner from "../assets/images/subspecialities/shape banners/CardiacImgBanner.png";
import MusculoskeletalImagingBanner from "../assets/images/subspecialities/shape banners/MusculoskeletalImgBanner.png";
import OncologyImagingBanner from "../assets/images/subspecialities/shape banners/OncologyImgBanner.png";
import VascularImagingBanner from "../assets/images/subspecialities/shape banners/VascularImagingBanner.png";

//CardsImage
import MRICard from "../assets/images/subspecialities/cards/MRICard.jpg";
import PETCard from "../assets/images/subspecialities/cards/PETCard.jpg";
import XRAYCard from "../assets/images/subspecialities/cards/XRAYCard.jpg";
import UltrasoundCard from "../assets/images/subspecialities/cards/ultrasoundCard.jpg";
import CtScanCard from "../assets/images/subspecialities/cards/CTScanCard.jpg";
import NuclearMedicineCard from "../assets/images/subspecialities/cards/NuclearMedicineCard.jpg";
import DEXACard from "../assets/images/subspecialities/cards/DEXACard.jpg";
import MamographyCard from "../assets/images/subspecialities/cards/MamographyCard.jpg";
import EchoCardiologyCard from "../assets/images/subspecialities/cards/EchocardiollogyCard.jpg";

//SubSpecialities Icons
import Body from "../assets/icons/Imaging-icon -BIG/kidney.png";
import Cardiac from "../assets/icons/Imaging-icon -BIG/cardiac.png";
import Men from "../assets/icons/Imaging-icon -BIG/man.png";
import MusculoSkeletal from "../assets/icons/Imaging-icon -BIG/bones.png";
import Neurology from "../assets/icons/Imaging-icon -BIG/brain.png";
import Oncology from "../assets/icons/Imaging-icon -BIG/oncology.png";
import personalInjury from "../assets/icons/Imaging-icon -BIG/injury.png";
import Vascular from "../assets/icons/Imaging-icon -BIG/vascular.png";
import Women from "../assets/icons/Imaging-icon -BIG/women.png";

//menu Icons
import BodyImagingIcon from "../assets/icons/MenuIcons/organs.png";
import CardiacImagingIcon from "../assets/icons/MenuIcons/heart.png";
import MensImagingIcon from "../assets/icons/MenuIcons/man.png";
import OncologyImagingIcon from "../assets/icons/MenuIcons/oncology.png";
import MusculoskeletalImagingIcon from "../assets/icons/MenuIcons/leg.png";
import NeurologicalImagingIcon from "../assets/icons/MenuIcons/brain.png";
import PersonalInjuryImagingIcon from "../assets/icons/MenuIcons/injury.png";
import VascularImagingIcon from "../assets/icons/MenuIcons/vascular-surgery.png";
import WomensImagingIcon from "../assets/icons/MenuIcons/women.png";

//mainImages
import BodyImaging from "../assets/images/subspecialities/maincontentImages/BodyImaging.jpg";
import CardiacImaging from "../assets/images/subspecialities/maincontentImages/CardiacImaging.jpg";
import MensImaging from "../assets/images/subspecialities/maincontentImages/MenImaging.jpg";
import MusculoskeletalImaging from "../assets/images/subspecialities/maincontentImages/MusculoskeletalImaging.jpg";
import NeurologicalImaging from "../assets/images/subspecialities/maincontentImages/NeurologicalImaging.jpg";
import OncologyImaging from "../assets/images/subspecialities/maincontentImages/OncologyImaging.jpg";
import PersonalInjuryImaging from "../assets/images/subspecialities/maincontentImages/PersonalInjuryImaging.jpg";
import VascularImaging from "../assets/images/subspecialities/maincontentImages/VascularImaging.jpg";
import WomensImaging from "../assets/images/subspecialities/maincontentImages/WomensImaging.jpg";

//Illustration Images
import CardiacIllu from "../assets/images/subspecialities/SubSpecialitiesIllustrations/Cardiac-Imaging-illu.png";
import BodyIllu from "../assets/images/subspecialities/SubSpecialitiesIllustrations/cd_scan_color.png";
import MenIllu from "../assets/images/subspecialities/SubSpecialitiesIllustrations/Men’s-Imaging-illu-01.png";
import MasculoskeletalIllu from "../assets/images/subspecialities/SubSpecialitiesIllustrations/Musculoskeletal-Imaging-illu.png";
import NeurologicalIllu from "../assets/images/subspecialities/SubSpecialitiesIllustrations/Neurological -Imaging-illu.png";
import OncologyIllu from "../assets/images/subspecialities/SubSpecialitiesIllustrations/Oncology -Imaging-illu.png";
import womensIllu from "../assets/images/subspecialities/SubSpecialitiesIllustrations/Women’s-Imaging-illu.png";
// import PersonalInjuryIllu from "../assets/images/subspecialities/SubSpecialitiesIllustrations/personal.png";
import PersonalInjuryIllu from "../assets/images/subspecialities/SubSpecialitiesIllustrations/CDC_new_1-01.png";
// import PersonalInjuryIllu from "../assets/images/subspecialities/SubSpecialitiesIllustrations/CDC_newe-01.png";
import VascularIllu from "../assets/images/subspecialities/SubSpecialitiesIllustrations/Vascular -Imaging-illu.png";

const SubSpecialitiesInfo = [
  {
    title: "Auto/Personal Injury Imaging",
    slug: "personal-injury-imaging",
    category: "Subspecialties",
    icon: personalInjury,
    menuIcon: PersonalInjuryImagingIcon,
    bannerimage: personalInjuryBanner,
    image: PersonalInjuryImaging,
    metaTitle: "Auto & Personal Injury Imaging | Brain Injury MRI Scans",
    metaDescription:
      "Citrus Diagnostic Center offers advanced imaging for auto and personal injuries, including detailed brain injury MRI scans for precise evaluation and recovery.",
    subdescription: `Precise Imaging for accurate evaluation`,
    description:
      "Personal injury imaging provides clarity in situations where trauma may not be immediately visible. At Citrus Diagnostic Center (CDC), our imaging studies reveal subtle fractures, ligament tears, internal bleeding, or soft tissue damage that often remain undetected during a routine examination. This level of precision allows treating physicians to develop accurate management plans, reducing the risk of complications and supporting faster recovery for patients.",
    whymatters: [
      {
        question: "Clinical Value of Personal Injury Imaging",
        answer: [
          "In cases of accidents, including road traffic collisions or physical trauma.",
          "To confirm or rule out bone fractures and joint dislocations following an injury.",
          "When internal bleeding is suspected and requires precise evaluation.",
          "To assess potential damage to soft tissues such as muscles, ligaments, or tendons.",
          "For patients experiencing persistent pain or restricted mobility after an incident.",
          "To track the progress of healing and recovery during follow-up care.",
        ],
        image: PersonalInjuryIllu,
      },
    ],
    modalities: {
      description:
        "Different health problems need different diagnostics. At CDC, we provide a range of imaging technologies to ensure accurate and detailed results.",
      list: [
        {
          name: "MRI",
          image: MRICard,
          uses: [
            "Identifies injuries to soft tissues like ligaments, tendons, and spinal or brain damage. It plays a key role in spotting hidden or complicated injuries that X-rays might miss.",
          ],
        },
        {
          name: "X-Ray",
          image: XRAYCard,
          uses: [
            "Shows fractures, dislocations, or issues with skeletal alignment after an injury. It is the fastest option to detect bone-related problems.",
          ],
        },
        {
          name: "Ultrasound",
          image: UltrasoundCard,
          uses: [
            "Provides radiation-free imaging to check for soft tissue damage, bleeding, joint inflammation, or ligament problems. It is safe to use.",
          ],
        },
        {
          name: "CT Scan",
          image: CtScanCard,
          uses: [
            "Useful to evaluate head trauma, spinal injury, severe fractures, or injuries involving multiple areas. It offers detailed images of bones, organs, and blood vessels.",
          ],
        },
      ],
    },
    faqs: [
      {
        question: "What if my injuries aren’t visible on the scan?",
        answer:
          "Sometimes, a  few injuries may not be clearly visible on the scan. Our physicians and radiologists are trained to provide accurate results and findings based on the symptoms you show.",
      },
      {
        question: "What if I take painkillers before the scan?",
        answer:
          "Please inform your technician prior to the scan. Pain medications may mask symptoms and influence the accuracy of the results.",
      },
    ],
    appointment: {
      title: "Schedule your Scan today",
      quote:
        "Don’t let confusion delay your healing. At Citrus Diagnostic Center, we give you clear, early answers to help you and your physician move forward, whether you need treatment, therapy, or evidence for a claim.",
    },
  },
  {
    title: "Body Imaging",
    slug: "body-imaging",
    category: "Subspecialties",
    icon: Body,
    menuIcon: BodyImagingIcon,
    bannerimage: BodyImagingBanner,
    image: BodyImaging,
    metaTitle: "Body Imaging and Chest Imaging – Citirus Diagnostic Center",
    metaDescription:
      "Citirus Diagnostic Center offers chest radiographs, lung CT scans, heart scans, and X-rays reviewed by expert chest radiologists for accurate, reliable results.",
    subdescription: `Seeing Beyond the Surface`,
    description: `Body Imaging plays a vital role in modern medicine, providing physicians with accurate, high-resolution insights into the chest, abdomen, pelvis, and musculoskeletal system. At Citrus Diagnostic Center (CDC), our advanced imaging technology and subspecialty-trained radiologists deliver precise, timely results that support confident clinical decision-making.`,
    whychoose: [
      {
        question: "We look Deeper, so you Heal better",
        answer: [
          "Access to advanced CT, MRI, ultrasound, and X-ray technologies.",
          "Interpretation by board certified radiologists with deep expertise in the sub-specialities offered at CDC.",
          "Reports delivered with precision, clarity, and clinical relevance.",
          "A patient-centered approach with emphasis on safety and comfort.",
        ],
      },
    ],
    whymatters: [
      {
        question: "Clinical Value of Body Imaging",
        answer: [
          "Early detection of cancers, cardiovascular disease, and gastrointestinal conditions.",
          "Evaluation of unexplained pain, bleeding, or organ dysfunction.",
          "Monitoring response to therapies in oncology and chronic disease management.",
          "Preoperative planning through precise visualization of anatomy.",
          "Assessment of bone health, trauma, and internal injury.",
          "Obstetric and neurological applications for comprehensive care.",
        ],
        image: BodyIllu,
      },
    ],
    modalities: {
      description:
        "Body imaging covers a range of advanced scans using modern technologies to scan every minute detail from your head to your pelvis, helping physicians carry out safe treatment plans.",
      list: [
        {
          name: "MRI",
          image: MRICard,
          uses: [
            "Identifies tumours, ligament injuries, brain or spinal issues, and problems in the musculoskeletal system.",
          ],
        },
        {
          name: "PET Scan",
          image: PETCard,
          uses: [
            "Examines disease at the cellular scale and can spot cancers. It also checks how the heart and brain are working.",
          ],
        },
        {
          name: "X-Ray",
          image: XRAYCard,
          uses: [
            "Works fast to show fractures, lung problems, arthritis, or chest infections.",
          ],
        },
        {
          name: "Ultrasound",
          image: UltrasoundCard,
          uses: [
            "Uses no radiation and is safe to use during pregnancy. It also checks thyroid, heart, abdomen, or breast concerns.",
          ],
        },
        {
          name: "CT Scan",
          image: CtScanCard,
          uses: [
            "Shows organs, bones, and blood vessels in detail. It helps find issues like cancer, internal bleeding, injuries, or heart disease.",
          ],
        },
        {
          name: "Nuclear Medicine",
          image: NuclearMedicineCard,
          uses: [
            "Detects hidden health problems such as thyroid issues, bone conditions, organ dysfunction, or infections.",
          ],
        },
        {
          name: "DEXA scan",
          image: DEXACard,
          uses: [
            "It is effective in diagnosing bone density loss and Osteoporosis.",
          ],
        },
      ],
    },
    faqs: [
      {
        question: "How long does a scan take?",
        answer:
          "Simple scans may take 15–20 minutes, while detailed studies can last up to an hour. Patients are usually awake and comfortable during the procedure.",
      },
      {
        question: "How are my imaging results kept private?",
        answer:
          "All results are securely stored and transmitted in compliance with HIPAA regulations to ensure patient confidentiality.",
      },
    ],
    appointment: {
      title: "Schedule your Scan today",
      quote:
        "Get Clarity on what your Body is trying to say with precise and accurate services carried out through expert radiologists.",
    },
  },
  {
    title: "Chest Imaging",
    slug: "chest-imaging",
    category: "Subspecialties",
    icon: Body,
    menuIcon: BodyImagingIcon,
    bannerimage: BodyImagingBanner,
    image: BodyImaging,
    metaTitle: "Body Imaging and Chest Imaging – Citirus Diagnostic Center",
    metaDescription:
      "Citirus Diagnostic Center offers chest radiographs, lung CT scans, heart scans, and X-rays reviewed by expert chest radiologists for accurate, reliable results.",
    subdescription: `Seeing Beyond the Surface`,
    description: `Body Imaging plays a vital role in modern medicine, providing physicians with accurate, high-resolution insights into the chest, abdomen, pelvis, and musculoskeletal system. At Citrus Diagnostic Center (CDC), our advanced imaging technology and subspecialty-trained radiologists deliver precise, timely results that support confident clinical decision-making.`,
    whychoose: [
      {
        question: "We look Deeper, so you Heal better",
        answer: [
          "Access to advanced CT, MRI, ultrasound, and X-ray technologies.",
          "Interpretation by board certified radiologists with deep expertise in the sub-specialities offered at CDC.",
          "Reports delivered with precision, clarity, and clinical relevance.",
          "A patient-centered approach with emphasis on safety and comfort.",
        ],
      },
    ],
    whymatters: [
      {
        question: "Clinical Value of Body Imaging",
        answer: [
          "Early detection of cancers, cardiovascular disease, and gastrointestinal conditions.",
          "Evaluation of unexplained pain, bleeding, or organ dysfunction.",
          "Monitoring response to therapies in oncology and chronic disease management.",
          "Preoperative planning through precise visualization of anatomy.",
          "Assessment of bone health, trauma, and internal injury.",
          "Obstetric and neurological applications for comprehensive care.",
        ],
        image: BodyIllu,
      },
    ],
    modalities: {
      description:
        "Body imaging covers a range of advanced scans using modern technologies to scan every minute detail from your head to your pelvis, helping physicians carry out safe treatment plans.",
      list: [
        {
          name: "MRI",
          image: MRICard,
          uses: [
            "Identifies tumours, ligament injuries, brain or spinal issues, and problems in the musculoskeletal system.",
          ],
        },
        {
          name: "PET Scan",
          image: PETCard,
          uses: [
            "Examines disease at the cellular scale and can spot cancers. It also checks how the heart and brain are working.",
          ],
        },
        {
          name: "X-Ray",
          image: XRAYCard,
          uses: [
            "Works fast to show fractures, lung problems, arthritis, or chest infections.",
          ],
        },
        {
          name: "Ultrasound",
          image: UltrasoundCard,
          uses: [
            "Uses no radiation and is safe to use during pregnancy. It also checks thyroid, heart, abdomen, or breast concerns.",
          ],
        },
        {
          name: "CT Scan",
          image: CtScanCard,
          uses: [
            "Shows organs, bones, and blood vessels in detail. It helps find issues like cancer, internal bleeding, injuries, or heart disease.",
          ],
        },
        {
          name: "Nuclear Medicine",
          image: NuclearMedicineCard,
          uses: [
            "Detects hidden health problems such as thyroid issues, bone conditions, organ dysfunction, or infections.",
          ],
        },
        {
          name: "DEXA scan",
          image: DEXACard,
          uses: [
            "It is effective in diagnosing bone density loss and Osteoporosis.",
          ],
        },
      ],
    },
    faqs: [
      {
        question: "How long does a scan take?",
        answer:
          "Simple scans may take 15–20 minutes, while detailed studies can last up to an hour. Patients are usually awake and comfortable during the procedure.",
      },
      {
        question: "How are my imaging results kept private?",
        answer:
          "All results are securely stored and transmitted in compliance with HIPAA regulations to ensure patient confidentiality.",
      },
    ],
    appointment: {
      title: "Schedule your Scan today",
      quote:
        "Get Clarity on what your Body is trying to say with precise and accurate services carried out through expert radiologists.",
    },
  },
  {
    title: "Cardiac Imaging",
    slug: "cardiac-imaging",
    category: "Subspecialties",
    icon: Cardiac,
    menuIcon: CardiacImagingIcon,
    bannerimage: CardiacImagingBanner,
    image: CardiacImaging,
    metaTitle: "Cardiac Imaging & Heart Scans – Citirus Diagnostic Center",
    metaDescription:
      "Citirus Diagnostic Center offers cardiac imaging, ultrasound, PET scan cardiology, and nuclear heart scanning tests for detailed and accurate heart evaluation.",
    subdescription: `Your Heart Health is Clearer than Ever`,
    description: ` At Citrus Diagnostic Center (CDC), we understand how essential heart health is to your overall well-being. Using advanced cardiac imaging technologies, we capture precise, detailed views of your heart and its vessels. These insights allow physicians to detect concerns early, plan effective treatments, and guide ongoing care with confidence.`,
    whymatters: [
      {
        question: "Clinical Value of Cardiac Care",
        answer: [
          "High-resolution imaging equipment provides clear, accurate views of the heart and surrounding vessels.",
          "Board-certified radiologists interpret studies with precision and clinical expertise.",
          "Non-invasive techniques help ensure patient comfort throughout the process.",
          "Rapid, reliable results are delivered directly to your physician for timely decisions.",
          "Dedicated support continues beyond the scan, offering patients reassurance and continuity of care.",
        ],
        image: CardiacIllu,
      },
    ],
    modalities: {
      description:
        "We provide detailed and reliable heart imaging options to help doctors understand how your heart functions.",
      list: [
        {
          name: "PET",
          image: PETCard,
          uses: [
            "Measures blood flow, detects coronary artery issues, and identifies damaged heart muscle. It suits overweight patients or those at significant risk.",
          ],
        },
        {
          name: "CT Scan",
          image: CtScanCard,
          uses: [
            "Produces sharp 3D images of the heart, highlights plaque in the arteries, and detects both genetic and acquired heart conditions.",
          ],
        },
        {
          name: "Nuclear Medicine",
          image: NuclearMedicineCard,
          uses: [
            "Monitors how blood moves through the heart to find blockages and estimates the seriousness of heart disease.",
          ],
        },
        {
          name: "Echocardiography",
          image: EchoCardiologyCard,
          uses: [
            "Uses sound waves instead of radiation to spot structural heart defects, weak heart muscle, malfunctioning valves, fluid near the heart, and abnormalities present since birth.",
          ],
        },
      ],
    },
    // conditionsDiagnosed: {
    //   title: "Conditions Diagnosed in Cardiac Imaging",
    //   description: "",
    //   points: [
    //     {
    //       title: "Heart failure",
    //       description:
    //         "It helps in detecting weak heart muscles and evaluates the efficiency with which the heart is pumping blood, which helps in determining the possibility of heart failure earlier and even tells the cause of it.",
    //     },
    //     {
    //       title: "Coronary artery disease",
    //       description:
    //         " It helps in examining the blood flow and helps in identifying any blockages present.",
    //     },
    //     {
    //       title: "Various Valve diseases",
    //       description:
    //         "It provides clear images of the heart valves, which is helpful in detecting the stenosis, leakage, regurgitation, or improper opening or closing of the valves, by also determining the complexity.",
    //     },
    //     {
    //       title: "Heart attack and damage caused",
    //       description:
    //         "It not only identifies the damage caused to the heart muscle but also the extent of the damage due to reduced blood supply during a heart attack, so that future complications can be prevented. ",
    //     },
    //     {
    //       title: "Structural abnormalities of the heart",
    //       description:
    //         " It examines for the defects in the heart present either from birth or changes happened over time in the heart structure, like a hole in the walls, swelling in certain parts or any abnormalities. ",
    //     },
    //   ],
    // },
    // preparation: [
    //   {
    //     title: "Before the test",
    //     color: "text-[#d78558]",
    //     description: [
    //       "If you are on certain medications, then you need to pause the medicine intake as instructed by your doctor.",
    //       "Depending on the type of scan, you will be asked by your doctor to fast for a few hours before the scan begins.",
    //       "It is strictly needed to avoid the intake of caffeine, energy drinks, alcohol, and chocolates for at least 24 hours before the test.",
    //       "You should be present in comfortable clothes and avoid wearing metal items and jewellery.",
    //     ],
    //   },
    //   {
    //     title: "During the test",
    //     color: "text-[#d78558]",
    //     description: [
    //       "You will have to lie down on the scanning table and stay still for clear images.",
    //       "The duration of the entire scan will not take more than 15 to 60 minutes.",
    //       "You won't be experiencing any pain as the cardiac imaging tests are non-invasive.",
    //       "In some cases, radiotracer elements will be used that will be injected in your blood vessels.",
    //     ],
    //   },
    //   {
    //     title: "After the test",
    //     color: "text-[#d78558]",
    //     description: [
    //       "When the radiotracer is used then it is advised to drink plenty of water to naturally flush out the element.",
    //       "Most of the patients feel comfortable after the tests and resume their daily activities.",
    //       "The results at CDC won't take longer than 48 hours, which will initially be reviewed by the radiologists and then forwarded to your doctor, from whom you can discuss further steps.",
    //     ],
    //   },
    // ],
    faqs: [
      {
        question: "Should I be worried about radiation exposure?",
        answer:
          "No. All imaging procedures adhere to international safety guidelines, ensuring radiation levels remain well within safe limits. While receiving a radiotracer or contrast, you may experience a brief sensation such as warmth or mild pinch, which is normal.",
      },
      {
        question: "What if a serious condition is detected during the scan?",
        answer:
          "If the scan identifies any concerning findings, our team will promptly communicate them to your primary physician, who will guide you through appropriate treatment options, medications, or recommended lifestyle adjustments.",
      },
    ],
    appointment: {
      title: "Schedule your Scan today",
      quote:
        "Decode your heart’s health and get accurate results with CDC’s expert radiologists using the advanced cardiac imaging technologies.",
    },
  },
  {
    title: "Men’s Imaging",
    slug: "mens-imaging",
    category: "Subspecialties",
    icon: Men,
    menuIcon: MensImagingIcon,
    bannerimage: MensBanner,
    image: MensImaging,
    metaTitle: "Men’s Imaging | CT Lung Screening and Lung Cancer CT Scan",
    metaDescription:
      "Men’s imaging provides MRI scan, CT lung screening, lung cancer CT scan, and healthy lung X-ray for accurate diagnosis, early detection, and better lung health.",
    subdescription: `Clear Insights for Stronger Health`,
    description: `Men’s Imaging emphasizes the evaluation of health conditions that are more common in men or require focused attention. From detailed assessments of the prostate and cardiovascular system to examinations of urinary and digestive health, every scan provides clarity that supports proactive care and long-term vitality. Our advanced imaging combined with medical expertise helps men take charge of their well-being at every stage of life.`,
    whychoose: [
      {
        question: " Clinical Value of Men’s Imaging",
        answer: [
          "Detecting prostate cancer at an early stage and evaluating prostate enlargement.",
          "Assessing cardiovascular health, particularly in men over 40 who may be at higher risk.",
          "Supporting the diagnosis of urinary difficulties and erectile dysfunction.",
          "Evaluating causes of pain, swelling, or inflammation.",
          "Identifying digestive disorders and hernias with accuracy.",
          "Serving as an integral component of annual health evaluations and age-related screenings.",
        ],
      },
    ],
    whymatters: [
      {
        question: "Focused Imaging for Men’s Health",
        answer: [
          "Imaging for men at CDC is approached with a balance of advanced technology and expert insight. Every scan is interpreted with an awareness of broader health concerns, offering physicians reliable information that guides treatment with confidence.",
        ],
        image: MenIllu,
      },
    ],
    modalities: {
      description:
        "Different health problems need different diagnostics. At CDC, we provide a range of imaging technologies to ensure accurate and detailed results.",
      list: [
        {
          name: "MRI",
          image: MRICard,
          uses: [
            "Provides sharp and precise images of soft tissues, the brain, spine, and prostate. It helps detect musculoskeletal problems, tumours, and nerve pressure.",
          ],
        },
        {
          name: "PET Scan",
          image: PETCard,
          uses: [
            "Tracks the spread of cancers like lung, colon, and prostate. It helps find active cancer cells and shows how treatments are working.",
          ],
        },
        {
          name: "X-Ray",
          image: XRAYCard,
          uses: [
            "shows chest problems, bone fractures, spinal issues, and arthritis with ease.Nuclear Medicine – Shows infections, swelling, cancer spread, and how organs work.",
          ],
        },
        {
          name: "Ultrasound",
          image: UltrasoundCard,
          uses: [
            "Used to check prostate health, kidney stones, bladder troubles, and testicular swelling or pain without invasive procedures.",
          ],
        },
        {
          name: "CT Scan",
          image: CtScanCard,
          uses: [
            "Gives clear pictures of blood vessels, internal organs, and bones. It works well for injuries, lung issues, stomach pain, and blood flow problems.",
          ],
        },
        {
          name: "Nuclear Medicine",
          image: NuclearMedicineCard,
          uses: [
            "Evaluates organ function, detects metabolic disorders, and assists in oncological assessments.",
          ],
        },
      ],
    },
    // conditionsDiagnosed: {
    //   title: "Conditions Often Diagnosed in Men’s Imaging",
    //   description: "",
    //   points: [
    //     {
    //       title: "Prostate enlargement or cancer",
    //       description:
    //         "It can be detected using MRI or Ultrasound, which are responsible for evaluating the prostate size, lesions and malignancy, which are important factors in determining the cancer",
    //     },
    //     {
    //       title: "Testicular lumps or cancer",
    //       description:
    //         "The presence of any lumps, tumours or any abnormality is identified, especially using the Scrotal Ultrasound.",
    //     },
    //     {
    //       title: "Erectile dysfunction",
    //       description:
    //         "It can be detected by assessing the blood flow in the penile region to determine any vascular cause behind the erectile dysfunction, where Doppler ultrasound can be used.",
    //     },
    //     {
    //       title: "Hernias and other abdominal masses",
    //       description:
    //         "They can be detected using CT scans or Ultrasound, which helps in determining their size, location and the additional complications that they carry.",
    //     },
    //     {
    //       title: "Cardiac issues",
    //       description:
    //         "With the help of advanced men’s imaging techniques, various heart problems related to functioning and structure, blockages in the arteries can be detected along with the indication towards heart diseases with early signs.",
    //     },
    //     {
    //       title: "Lung infections and diseases",
    //       description:
    //         "Chest X-rays and CT scans are extremely helpful for diagnosing respiratory diseases like pneumonia, tuberculosis, lung cancer, and other respiratory conditions.",
    //     },
    //     {
    //       title: "Brain tumours and stroke",
    //       description:
    //         "MRI and CT scans are widely used to detect brain tumours, blood clots, stroke and the damage caused for precise treatment.",
    //     },
    //     {
    //       title: "Fracture and bone displacement",
    //       description:
    //         "X-ray scans are considered highly effective to confirm fractures, joint dislocations, and other bone injuries.",
    //     },
    //     {
    //       title: "Kidney stones",
    //       description:
    //         "The presence of kidney stones is detected using CT scans and Ultrasound, which helps in identifying the presence, size, and exact location of kidney stones.",
    //     },
    //     {
    //       title: "Gastrointestinal issues",
    //       description:
    //         "To detect the issues related to the digestive system, like inflammation, tumours, bowel obstructions, imaging scans like endoscopic ultrasound, CT, and MRI are used.",
    //     },
    //   ],
    // },
    // preparation: [
    //   {
    //     title: "Before the test",
    //     color: "text-[#d78558]",
    //     description: [
    //       "For certain scans, you will need to fast before the test as instructed by your doctor.",
    //       "You will have to remove any accessories like a belt, watch, and other metallic objects for proper results.",
    //       "If you are dealing with any kind of allergies or have metal implants, then you must inform your doctors. ",
    //     ],
    //   },
    //   {
    //     title: "During the test",
    //     color: "text-[#d78558]",
    //     description: [
    //       "It is advised to lie still while testing for clear images.",
    //       "The MRI machine produces a mild sound, which can create noise; however, you will be provided with earplugs to cut down the noise.",
    //       "If the contrast dye is used, then the patient might feel a warm sensation and a metallic taste in their mouth. It won't last for a long time.",
    //       "Most of the scans are painless and non-invasive and will take around 15-45 minutes, depending on the type of scan you are undergoing.",
    //     ],
    //   },
    //   {
    //     title: "After the test",
    //     color: "text-[#d78558]",
    //     description: [
    //       "Most patients feel alright after the examination and can safely resume their daily activities.",
    //       "You may feel mild nausea or minor side effects like rashes or dizziness if contrast dye is used. If the symptoms persist, then immediately inform your doctor.",
    //       "At CDC, your detailed results are ready in 48 hours, which will be reviewed by the radiologists and then sent to your doctor, from where you can have further discussion on the later procedures.",
    //     ],
    //   },
    // ],
    faqs: [
      {
        question:
          "Can I get an imaging examination after a long workday or a workout?",
        answer:
          "It is fine if you are getting examined after your workouts, or even if you appear after long working shifts. It is ideally recommended to have enough rest and be hydrated.",
      },
      {
        question: "Is preparation required for urinary or prostate imaging?",
        answer:
          "Our technologists will pause and resume the scan in such cases. However, you will have access to a call button for any help. ",
      },
    ],
    appointment: {
      title: "Schedule your Scan today",
      quote:
        "Some procedures may require hydration, fasting, or avoiding certain medications. Detailed instructions are provided prior to your scan.",
    },
  },
  {
    title: "Musculoskeletal Imaging",
    slug: "musculoskeletal-imaging",
    category: "Subspecialties",
    icon: MusculoSkeletal,
    menuIcon: MusculoskeletalImagingIcon,
    bannerimage: MusculoskeletalImagingBanner,
    image: MusculoskeletalImaging,
    metaTitle: "Musculoskeletal MRI and Bone Scan | Citirus Diagnostic Center",
    metaDescription:
      "Experience advanced musculoskeletal MRI, bone scan tests, and ultrasound imaging at Citirus Diagnostic Center for accurate bone, joint, and muscle evaluation.",
    subdescription: `Keeping you active with precise diagnosis`,
    description: `Musculoskeletal imaging is a subspecialty of diagnostic radiology focused on evaluating bones, joints, muscles, and surrounding soft tissues. With a multimodality approach, our radiologists collaborate closely with referring physicians to create clear diagnostic pathways. This integrated process not only identifies injuries and diseases but also helps patients and their care teams in moving forward with the most effective treatment options.`,
    whymatters: [
      {
        question: "Clinical Value of Musculoskeletal Imaging",
        answer: [
          "Detailed imaging for fractures, arthritis, sports injuries, and degenerative conditions",
          "Advanced scans of muscles, tendons, and ligaments for precise diagnosis of tears or inflammation",
          "Clear insights into joint health to support timely medical or surgical care",
          "Early detection and characterization of tumors, cysts, and musculoskeletal infections",
          "Accurate assessment of healing, prosthesis performance, and potential post-surgical complications",
          "Close collaboration with referring physicians to ensure imaging pathways align with each patient’s needs",
        ],
        image: MasculoskeletalIllu,
      },
    ],
    modalities: {
      description:
        "Different health problems need different diagnostics. At CDC, we provide a range of imaging technologies to ensure accurate and detailed results.",
      list: [
        {
          name: "MRI",
          image: MRICard,
          uses: [
            "Uses no radiation and shows clear pictures of joints, cartilage, ligaments, and soft tissues. Works well to find small injuries or understand tough joint problems.",
          ],
        },
        {
          name: "PET",
          image: PETCard,
          uses: [
            "Spot cancer, bone infections, or diseases through changes in metabolism. Helps check if cancer has moved to the bones.",
          ],
        },
        {
          name: "X-Ray",
          image: XRAYCard,
          uses: [
            "Quick and budget-friendly, it works well to find fractures, arthritis, or problems with bone alignment.",
          ],
        },
        {
          name: "Ultrasound",
          image: UltrasoundCard,
          uses: [
            "Safe to use on everyone, even pregnant women. It helps see injuries in tendons, muscles, or ligaments and finds joint cysts or fluid buildup.",
          ],
        },
        {
          name: "CT Scan",
          image: CtScanCard,
          uses: [
            "Shows detailed cross-sections of bones and joints. Doctors use it to spot trauma injuries or fractures missed on X-rays.",
          ],
        },
        {
          name: "Nuclear Medicine",
          image: NuclearMedicineCard,
          uses: [
            "Helps find bone infections, tumors, hidden fractures, and even swelling. It has a strong ability to detect these issues.",
          ],
        },
        {
          name: "DEXA",
          image: DEXACard,
          uses: [
            "Checks bone density to assess osteoporosis risk and predicts the chances of fractures. This is crucial to help older adults.",
          ],
        },
      ],
    },
    // conditionsDiagnosed: {
    //   title: "Conditions diagnosed with Musculoskeletal imaging",
    //   description: "",
    //   points: [
    //     {
    //       title: "Bone fractures and dislocations",
    //       description:
    //         "Musculoskeletal imaging helps in detecting the bone fracture, be it major or minor, or any misalignment in joints that happened due to an accident.",
    //     },
    //     {
    //       title: "Arthritis",
    //       description:
    //         " It is very effective in identifying cartilage loss, joint inflammation or changes in the bone structure, which are the indications of arthritis.",
    //     },
    //     {
    //       title: "Muscle strain",
    //       description:
    //         "It helps in identifying the strain caused in the muscle due to overstretching during sport, injuries, accidents or trauma.",
    //     },
    //     {
    //       title: "soft tissue issues",
    //       description:
    //         "Musculoskeletal imaging helps in detecting injuries in tendons, ligaments or connecting tissues.",
    //     },
    //     {
    //       title: "Osteoporosis",
    //       description:
    //         "Osteoporosis is a condition where bone mass density decreases, which can be detected and treated using musculoskeletal imaging.",
    //     },
    //     {
    //       title: "Bone thinning",
    //       description:
    //         "Bone thinning is a condition where the bone strength is decreased, which increases the risk of fracture.",
    //     },
    //   ],
    // },
    // preparation: [
    //   {
    //     title: "Before the test",
    //     color: "text-[#d78558]",
    //     description: [
    //       "You will have to remove any jewellery or metal objects to avoid interference.",
    //       "You should be in comfortable clothes.",
    //       "For certain scans like PET/CT, you will need to fast for a few hours before your examination as instructed by the doctor.",
    //       "You must inform your doctor and radiologists about your implants, allergies, or medical conditions..",
    //     ],
    //   },
    //   {
    //     title: "During the test",
    //     color: "text-[#d78558]",
    //     description: [
    //       "You will need to lie on the scanning table and must stay still for accurate and clear images.",
    //       "Many scans are painless and non-invasive and will hardly take 30-60 minutes.",
    //       "If your scan includes the contrast dye, then you may feel a mild pinch while injecting it.",
    //     ],
    //   },
    //   {
    //     title: "After the test",
    //     color: "text-[#d78558]",
    //     description: [
    //       "Most of the patients feel comfortable resuming their daily activities after the test.",
    //       "If tracers were used, then it is advised to drink plenty of fluids to naturally flush out the elements.",
    //       "Your test reports will be ready within 48 hours, which will be reviewed by your radiologists and then sent to your doctor.",
    //     ],
    //   },
    // ],
    faqs: [
      {
        question: "Can pregnant women undergo musculoskeletal imaging?",
        answer:
          "Yes. Pregnant patients can safely undergo MRI and ultrasound examinations. For imaging studies involving radiation, your physician may recommend alternative approaches to ensure safety.",
      },
      {
        question: "What if I have tattoos containing metallic ink?",
        answer:
          "Some metallic tattoo inks can occasionally interact with the MRI scanner, potentially causing mild irritation. Please inform your technologist beforehand so appropriate precautions can be taken during the scan.",
      },
    ],
    appointment: {
      title: "Schedule your Scan today",
      quote:
        "Don’t hold back because of your doubts. At Citrus Diagnostic Center, we give you clear answers to help you recover, stay active, and live stronger with confidence",
    },
  },
  {
    title: "Neurological Imaging",
    slug: "neurology-imaging",
    category: "Subspecialties",
    icon: Neurology,
    menuIcon: NeurologicalImagingIcon,
    bannerimage: NeurologicalBanner,
    image: NeurologicalImaging,
    metaTitle: "Neurological and Brain MRI Scans | Citirus Diagnostic Center",
    metaDescription:
      "Citirus Diagnostic Center provides brain MRI, MRI head scans, functional and contrast MRI, offering advanced neurological imaging for accurate, clear results.",
    subdescription: `Precise View of the Nervous System`,
    description: `The brain and nervous system are at the core of every human function—thought, movement, memory, and sensation. Even subtle changes can signal significant underlying conditions, making timely and precise evaluation crucial. At Citrus Diagnostic Center (CDC), our advanced neurological imaging delivers highly detailed views of the brain, spine, and nervous system, helping uncover conditions that often remain hidden in routine evaluations.`,
    whymatters: [
      {
        question: "Clinical Value of Neurological Imaging",
        answer: [
          "Assesses sudden neurological symptoms such as dizziness, weakness, or sensory changes",
          "Detects traumatic injuries to the brain or spinal cord",
          "Identifies tumors and abnormal growths with clarity",
          "Provides rapid evaluation in stroke to measure brain impact and guide urgent care",
          "Investigates causes of memory loss, confusion, or cognitive decline",
          "Reveals signs of infection or inflammation within the nervous system",
        ],
        image: NeurologicalIllu,
      },
    ],
    modalities: {
      description:
        "Different health problems need different diagnostics. At CDC, we provide a range of imaging technologies to ensure accurate and detailed results.",
      list: [
        {
          name: "MRI",
          image: MRICard,
          uses: [
            "Gives detailed pictures of the brain, spine, and soft tissues. Doctors rely on it to find tumors, injuries, infections, or degenerative conditions without any exposure to harmful radiation.",
          ],
        },
        {
          name: "PET",
          image: PETCard,
          uses: [
            "Shows how the brain works and uses energy. It helps tell Alzheimer’s apart from other dementias, find tumors, and track how well treatments are working.",
          ],
        },
        {
          name: "Ultrasound",
          image: UltrasoundCard,
          uses: [
            "Doctors use this for infants to study brain blood flow and detect birth defects. It also has a role in finding issues in blood vessels.",
          ],
        },
        {
          name: "Nuclear Medicine",
          image: NuclearMedicineCard,
          uses: [
            "This scans for problems that regular MRI or CT scans might miss. It can check brain blood flow, seizure conditions, dementia, and brain activity.",
          ],
        },
      ],
    },
    // conditionsDiagnosed: {
    //   title: "Conditions diagnosed in Neurology tests",
    //   description: "",
    //   points: [
    //     {
    //       title: "Brain injuries",
    //       description:
    //         "It is the best choice for detecting any brain injuries, damage or bleeding happening inside the brain due to trauma or accident.",
    //     },
    //     {
    //       title: "Tumours in the brain and spine",
    //       description:
    //         "It effectively identifies and detects abnormal growth in the central nervous system.",
    //     },
    //     {
    //       title: "Stroke",
    //       description:
    //         "It helps with the identification of the blockages and the bleeding in the brain vessels.",
    //     },
    //     {
    //       title: "Infections in the brain",
    //       description:
    //         " It effectively helps in detecting conditions like meningitis or encephalitis so that proper treatment can be planned. ",
    //     },
    //     {
    //       title: "Neurodegenerative diseases",
    //       description:
    //         "It helps in identifying diseases like Alzheimer's, parkinsons, dementia, and other diseases.",
    //     },
    //     {
    //       title: "Spinal cord injuries",
    //       description:
    //         "It helps in locating the part of the spine where damage has been caused and examines the spine.",
    //     },
    //     {
    //       title: "Certain neurological conditions in infants",
    //       description:
    //         "It effectively identifies the disorders and congenital issues among the infants and growing children.",
    //     },
    //     {
    //       title: "Headaches",
    //       description:
    //         " It helps in diagnosing the reason for the chronic headaches, migraine and other conditions.",
    //     },
    //     {
    //       title: "Sleep disorders",
    //       description:
    //         "It effectively analyses and diagnoses conditions like sleep apnea, narcolepsy, and other sleeping conditions. ",
    //     },
    //     {
    //       title: "Neurovascular disorder",
    //       description:
    //         " It effectively examines the abnormalities in the blood vessels of the brain and spine.",
    //     },
    //   ],
    // },
    // preparation: [
    //   {
    //     title: "Before the test",
    //     color: "text-[#d78558]",
    //     description: [
    //       "You will be asked about your medical history and existing medical condition, based on which the scan will be decided.",
    //       "Depending on the type of scan, you will be notified to fast and avoid drinking water few hours before the test begins.",
    //       "It is important to inform your doctors beforehand if you have any implants, if you are pregnant, or any allergies.",
    //     ],
    //   },
    //   {
    //     title: "During the test",
    //     color: "text-[#d78558]",
    //     description: [
    //       "Before your actual scanning begins, a physical examination will be conducted to check your reflexes, balance, coordination, and muscle strength.",
    //       "A simple memory or cognitive exam will be conducted in a few cases.",
    //       "You will have to lie down still for about 15-60 minutes based on the type of scan you are undergoing.",
    //       "Although all the tests are painless but if contrast dye is involved, then you might feel a mild pinch while injecting it.",
    //     ],
    //   },
    //   {
    //     title: "After the test",
    //     color: "text-[#d78558]",
    //     description: [
    //       "Most patients return to their normal activities right after the tests.",
    //       "If contrast dye is used, then you will have to drink plenty of water to naturally flush it out.",
    //       "Usually, there are no side effects from any test. However, if you experience symptoms such as dizziness, nausea, or rashes, please inform your doctor immediately.",
    //       "The radiologists will review your detailed reports and then share them with your doctors within 48 hours.",
    //     ],
    //   },
    // ],
    faqs: [
      {
        question:
          "If I’m stressed or anxious, will it affect the quality of my results?",
        answer:
          "Emotional stress or anxiety can occasionally influence scan accuracy. Please inform your examiner if you are feeling anxious, so appropriate measures can be taken to ensure precise results.",
      },
      {
        question:
          "Can neurological imaging detect hidden brain injuries after trauma?",
        answer:
          "Yes. MRI and CT scans can identify subtle concussions, micro-bleeds, or structural damage that may not show up on standard exams.",
      },
    ],
    appointment: {
      title: "Schedule your Scan today",
      quote:
        "At Citrus Diagnostic Center, we combine advanced imaging tools with expert radiologist insights to give you clarity and confidence.",
    },
  },
  {
    title: "Oncology Imaging",
    slug: "oncology-imaging",
    category: "Subspecialties",
    icon: Oncology,
    menuIcon: OncologyImagingIcon,
    bannerimage: OncologyImagingBanner,
    image: OncologyImaging,
    metaTitle: "Advanced Oncology Imaging and PSMA Scanning in Crystal river",
    metaDescription:
      "Detect cancer early with advanced oncology imaging, PET, and PSMA scans. Get accurate results and precise diagnosis for effective cancer treatment planning.",
    subdescription: `Detects Cancer earlier, and with confidence`,
    description: `Oncology Imaging plays a pivotal role in modern cancer care, providing clarity at every stage of the patient’s journey. Our advanced imaging systems allow for the earliest possible detection of tumors, precise localization, and thorough assessment of how far the disease has progressed. They also support clinicians in planning appropriate treatment approaches, monitoring response, and identifying any signs of recurrence, ensuring care is guided by reliable and accurate insights.
`,
    whymatters: [
      {
        question: "Clinical Value of Oncology Imaging",
        answer: [
          "Early identification of abnormal growths within the body.",
          "Confirmation of cancer presence with accuracy.",
          "Evaluation of cancer spread across different areas.",
          "Planning of therapies, medications, and treatment pathways.",
          "Monitoring treatment response and detecting recurrence when necessary.",
        ],
        image: OncologyIllu,
      },
    ],
    modalities: {
      description:
        "We offer you advanced imaging technologies designed to support cancer detection and care. Our scans provide precise, high-resolution images that not only detect the presence of cancer but also help identify tumors at their early stages, determine their size, and track their growth.",
      list: [
        {
          name: "MRI",
          image: MRICard,
          uses: [
            "It gives detailed 3D images of the brain, spine, breasts, abdomen, and pelvis. Doctors use it to check for tumours and during follow-ups.",
          ],
        },
        {
          name: "PET",
          image: PETCard,
          uses: [
            "This test shows if cancer cells are active, checks how far cancer has spread, and tracks how well treatment works at the cell level.",
          ],
        },
        {
          name: "X-Ray",
          image: XRAYCard,
          uses: [
            "A quick and low-cost method. It works great for spotting lung cancer, bone cancer, or finding large lumps.",
          ],
        },
        {
          name: "Ultrasound",
          image: UltrasoundCard,
          uses: [
            "Uses no radiation. It displays images of soft tissue cancers in areas like the liver, pelvis, kidney, and breasts.",
          ],
        },
        {
          name: "CT Scan",
          image: CtScanCard,
          uses: [
            "It produces cross-sectional visuals of the body. It helps figure out the size, density, and stage of tumours and where they have spread.",
          ],
        },
        {
          name: "Nuclear Medicine",
          image: NuclearMedicineCard,
          uses: [
            "Allows doctors to find cancer in bones, lymph nodes, and glands that other scans might not catch.",
          ],
        },
      ],
    },
    faqs: [
      {
        question: "Is nuclear medicine used in oncology imaging?",
        answer:
          "Yes. Nuclear medicine, including PET scans, uses safe, low-dose radioactive tracers to evaluate organ function and detect cancer at early stages.",
      },
      {
        question: "Are there age-related considerations for oncology imaging?",
        answer:
          "Yes. Imaging protocols may be adapted based on age, medical history, and risk factors to ensure safety and optimal diagnostic accuracy.",
      },
    ],
    appointment: {
      title: "Schedule your Scan today",
      quote:
        "Take the first step towards clarity about your internal health and uncover the presence of any abnormalities or tumours at the early stage itself.",
    },
  },

  {
    title: "Vascular Imaging",
    slug: "vascular-imaging",
    category: "Subspecialties",
    icon: Vascular,
    menuIcon: VascularImagingIcon,
    bannerimage: VascularImagingBanner,
    image: VascularImaging,
    metaTitle: "Vascular Ultrasound and Doppler Scans for Blood Flow Tests",
    metaDescription:
      "Experience advanced vascular imaging and Doppler ultrasound technology for precise blood flow testing, blockage detection, and comprehensive vascular care.",
    subdescription: `Detecting the health of arteries and veins`,
    description:
      "A healthy vascular system is essential for overall well-being. Any disruption in blood flow can impact organs, muscles, and general health. At our center, we provide advanced, non-invasive vascular imaging to give a clear and accurate view of your veins, arteries, and circulation, helping your physician make informed decisions to protect your health.",
    whymatters: [
      {
        question: "Clinical Value of Vascular Imaging",
        answer: [
          "Identifies blood clots and early vascular obstructions, enabling timely preventive care.",
          "Evaluates arterial narrowing or blockages that may compromise organ function.",
          "Detects vessel dilations and aneurysms before they pose critical risks.",
          "Monitors venous insufficiency and varicose vein progression with clarity.",
          "Examines carotid and cerebral circulation to aid in stroke prevention.",
        ],
        image: VascularIllu,
      },
    ],
    modalities: {
      description:
        "Different health problems need different diagnostics. At CDC, we provide a range of imaging technologies to ensure accurate and detailed results.",
      list: [
        {
          name: "MRI",
          image: MRICard,
          uses: [
            "Shows blood vessel issues like blockages, narrowing, or unusual formations. Doctors use it to study blood circulation in the brain, neck, chest, abdomen, and limbs.",
          ],
        },
        {
          name: "Ultrasound",
          image: UltrasoundCard,
          uses: [
            "Captures live images of blood movement. Helpful in finding deep vein thrombosis (DVT), varicose veins, and poor blood flow in the arms, legs, neck, or abdomen.",
          ],
        },
        {
          name: "CT Scan",
          image: CtScanCard,
          uses: [
            "Creates detailed 3D images of veins and arteries. Crucial in spotting strokes, leaks, or dealing with complex vascular emergencies needing fast, accurate results.",
          ],
        },
      ],
    },
    faqs: [
      {
        question:
          "Can vascular imaging detect early signs of heart attack or stroke?",
        answer:
          "Yes. It can identify plaque, narrowing, or aneurysms in arteries, helping physicians assess risk and guide preventive or therapeutic measures.",
      },
      {
        question:
          "Can vascular imaging help with varicose veins or venous insufficiency?",
        answer:
          "Absolutely. Ultrasound can map venous pathways, detect reflux, and guide treatment for varicose veins and other venous disorders.",
      },
    ],
    appointment: {
      title: "Schedule your Scan today",
      quote:
        "Don’t let circulation issues become life-threatening. At Citrus Diagnostic Center, we use advanced imaging to give clear insights into the health of your veins, arteries, and overall circulation.",
    },
  },
  {
    title: "Women’s Imaging",
    slug: "women-imaging",
    category: "Subspecialties",
    icon: Women,
    menuIcon: WomensImagingIcon,
    bannerimage: womensBanner,
    image: WomensImaging,
    metaTitle: "Women’s Imaging and Radiology – Citirus Diagnostic Center",
    metaDescription:
      "Citirus Diagnostic Center offers women’s imaging, breast ultrasound, mammography screening, and prenatal imaging with expert radiologists for accurate results.",
    subdescription: `Compassionate Care. Clear Answers.`,
    description: `At Citrus Diagnostic Centre, we put women’s health first. As pioneers in advanced diagnostic imaging, we combine cutting-edge technology with personalized attention. Our goal is simple — to deliver precise results while ensuring every woman feels supported, respected, and at ease.`,
    whymatters: [
      {
        question: "Clinical Value of Women’s Imaging",
        answer: [
          "Facilitates early detection and monitoring of breast cancer to improve treatment outcomes.",
          "Provides in-depth evaluation of reproductive organs, including the uterus, ovaries and fallopian tubes.",
          "Supports the diagnosis of menstrual irregularities, pelvic discomfort and infertility issues.",
          "Assesses maternal and fetal health during pregnancy, including placental function and fetal development.",
          "Identifies causes of pelvic or abdominal swelling, cysts, fibroids and other abnormalities.",
          "Includes screening mammograms and specialized biopsies to offer a comprehensive overview of women’s health.",
        ],
        image: womensIllu,
      },
    ],
    modalities: {
      description:
        "Different health problems need different diagnostics. At CDC, we provide a range of imaging technologies to ensure accurate and detailed results.",
      list: [
        {
          name: "MRI",
          image: MRICard,
          uses: [
            "Ideal for detecting gynecological issues, breast abnormalities, and cancers, and brain or spine conditions with clarity.",
          ],
        },
        {
          name: "PET",
          image: PETCard,
          uses: [
            "Effectively tracks active tumours, cancer presence and its spread, along with the stage, and evaluates functioning of tissues and organs.",
          ],
        },
        {
          name: "X-Ray",
          image: XRAYCard,
          uses: [
            "It effectively captures the bone fracture, chest infections and any abnormalities in the bone.",
          ],
        },
        {
          name: "Ultrasound",
          image: UltrasoundCard,
          uses: [
            "A safe scanning procedure for pregnancy, reproductive health, and extremely safe for fertility check-ups.",
          ],
        },
        {
          name: "CT Scan",
          image: CtScanCard,
          uses: [
            "A fast and effective scan for detecting internal injuries, kidney stones, and cancer staging.",
          ],
        },
        {
          name: "Nuclear Medicine",
          image: NuclearMedicineCard,
          uses: [
            "It reveals organ functioning, spread of cancer, thyroid disorders, and other hidden diseases. ",
          ],
        },
        {
          name: "DEXA",
          image: DEXACard,
          uses: [
            "Measures bone density and detects fracture risks, especially after women hit their menopause.",
          ],
        },
        {
          name: "Mammography",
          image: MamographyCard,
          uses: [
            "Effectively catches breast cancer at the early stage, even before symptoms starts appearing.",
          ],
        },
      ],
    },
    faqs: [
      {
        question: "What if I have breast implants?",
        answer:
          "Please notify your physician prior to the scan if you have breast implants. Appropriate imaging techniques will be used to ensure accurate results while prioritizing your safety and comfort.",
      },
      {
        question: "Are women’s imaging procedures safe during pregnancy? ",
        answer:
          "Ultrasound and MRI without contrast are safe and provide essential information about maternal and fetal health.",
      },
    ],
    appointment: {
      title: "Schedule your Scan today",
      quote:
        "Don’t wait till your common health issues turn life-threatening. At Citrus Diagnostic Center, we use advanced imaging to give clear insights into women’s health.",
    },
  },
];
export default SubSpecialitiesInfo;
